<template>
    <a-modal
            :title="title"
            :width="640"
            :visible="visible"
            @cancel="handleClose"
    >

        <p v-for="record in recordList">
            [面额：{{record.value}}元券，所需积分：{{record.point}}分，发行总量：{{record.totalAmount}}张，已兑换：{{record.consumeAmount}}张]
        </p>
        <p v-if="recordList.length === 0">无记录</p>

        <template slot="footer">
            <a-button key="submit" type="primary" @click="handleClose">
                确定
            </a-button>
        </template>
    </a-modal>
</template>

<script>
    import vendorService from "../../../service/vendor"
    import {Icon} from "ant-design-vue";
    import moment from "moment"

    export default {
        data () {
            return {
                // Modal统一数据
                dialogData: {},
                title: {},
                visible: false,

                recordList: []
            }
        },
        methods: {
            showModal(title, data) {
                this.title = title
                this.dialogData = data
                this.visible = true

                vendorService.couponList( {vendorId: data}).then((res) => {
                    this.recordList = res.data
                    for(let record of this.recordList) {
                        record.updateTime = moment(new Date(record.updateTime)).format("YYYY-MM-DD HH:mm:ss")
                        switch (parseInt(record.type)) {
                            case 1:
                                record.type="从平台充值获得";
                                break;
                            case 2:
                                record.type="用户兑换消费券获得";
                                break;
                            case 3:
                                record.type="用户消费赠送积分消耗";
                                break;
                            case 4:
                                record.type="平台提现消耗";
                                break;
                            case 5:
                                record.type="平台扣减商户积分消耗";
                                break;
                        }
                    }
                })
            },
            handleClose () {
                this.visible = false
            },
        }
    }
</script>

<style scoped>

</style>
